import Vue from 'vue';
import railsAxios from '../../../lib/railsAxios';
import getBlackboxPromise from '../../../tracking/iovation/getBlackboxPromise';
import submitRegPage from './submitRegPage';
import { trackPageView } from '../../../tracking/adobe';

const actions = {
  async checkReg1Completed(context) {
    let isComplete = context.getters.reg1DataFilled;
    if (!isComplete) {
      const result = await context.dispatch('fetchAndUpdateState', undefined, { root: true });
      if (result === false) {
        return 'redirect';
      }
      isComplete = context.getters.reg1DataFilled;
    }
    await context.dispatch('checkForMainPhoneNumber');
    return isComplete;
  },
  async checkReg2Completed(context) {
    let isComplete = context.getters.reg2DataFilled;
    if (!isComplete) {
      const result = await context.dispatch('fetchAndUpdateState', undefined, { root: true });
      if (result === false) {
        return 'redirect';
      }
      isComplete = context.getters.reg2DataFilled;
    }
    return isComplete;
  },
  clearBank({ commit, state }) {
    commit('SET_REG3', {
      ...state.reg3,
      bank_name:           null,
      bank_branch:         null,
      bank_account_number: null,
    });
  },
  submitReg1(context) {
    const payload = { user: context.state.reg1 };
    sessionStorage.seenWhatsappThisSession = true;
    return submitRegPage(context, payload, 'registrar');
  },
  async submitReg2(context) {
    const payload = {
      user: {
        ...context.state.reg2,
        main_phone:                   context.state.reg1.main_phone,
        privacy_policy:               context.state.reg1.privacy_policy,
        whatsapp_consent:             context.state.reg1.whatsapp_consent,
        positive_credit_data_consent: context.state.reg1.positive_credit_data_consent,
        io_black_box:                 await getBlackboxPromise(),
      },
    };
    sessionStorage.seenWhatsappThisSession = true;
    return submitRegPage(context, payload, 'pessoal');
  },
  async submitReg3(context) {
    const payload = { user: context.state.reg3 };
    return submitRegPage(context, payload, 'financeiro');
  },
  async submitOffer(context, payload) {
    return submitRegPage(context, payload, 'loan_offers');
  },
  async submitOptInStatus({ commit, dispatch }, payload) {
    const submitPath = '/api/v1/account-home/opt-in';
    const response = await railsAxios.post(submitPath, payload);
    const { data, errors } = response.data;

    if (!errors) {
      commit('SET_BACKEND_ERRORS', null, { root: true });
      commit('SET_BACKEND_ERROR_MESSAGES', null, { root: true });
      dispatch('mergeState', { loanApplication: data }, { root: true });
      trackPageView(submitPath);
    } else {
      commit('SET_BACKEND_ERRORS', errors, { root: true });
      commit('SET_BACKEND_ERROR_MESSAGES', data, { root: true });
    }

    return response;
  },
  checkForMainPhoneNumber({ commit, state }) {
    if (state.reg1.main_phone !== null && state.reg1.main_phone !== '') {
      commit('SET_HAS_MAIN_PHONE_NUMBER', true);
    }
  },
  async fetchMinimumMonthlyIncome({ commit }) {
    try {
      const response = await railsAxios.get('/api/minimum-monthly-income');
      const { data, errors } = response.data;
      if (!errors) {
        commit('SET_MINIMUM_MONTHLY_INCOME', data);
      }
    } catch (error) {
      // Data from call not required
      // No need to flash error message here
      // Logging happens in railsAxios
    }
  },
  async fetchConsents({ commit, state }) {
    try {
      const response = await railsAxios.get('/api/consent-statuses');
      const {
        data: {
          scr: scrConsented,
          whatsapp: whatsappConsented,
          positive_credit_data: positiveCreditDataConsented,
        },
        errors,
      } = response.data;
      if (errors) return;
      commit('SET_REG2', {
        ...state.reg2,
        privacy_policy:               scrConsented ? '1' : '0',
        whatsapp_consent:             whatsappConsented ? '1' : '0',
        positive_credit_data_consent: positiveCreditDataConsented ? '1' : '0',
      });
      commit('SET_HAS_VALID_SCR_CONSENT', scrConsented);
      commit('SET_HAS_WHATSAPP_CONSENT', whatsappConsented);
      commit('SET_HAS_POSITIVE_CREDIT_DATA_CONSENT', positiveCreditDataConsented);
    } catch (error) {
      // Data from call not required
      // No need to flash error message here
      // Logging happens in railsAxios
    }
  },
  // fetch zip codes from postcoder, and return a list of fields updated.
  async fetchZipCodes({ commit, state }) {
    const stateZipcode = state.reg2.zipcode.split('-').join('');
    try {
      const updatedFields = [];
      const response = await railsAxios.get(`/zip_codes/${stateZipcode}`);
      const { errors, zipcode, ...data } = response.data;
      // assigning data this way does not copy errors or zipcode prop.
      if (!errors) {
        const newReg2 = { ...state.reg2 };
        Vue.lodash.each(['street_address', 'city', 'state'], (field) => {
          if (data[field]) {
            newReg2[field] = data[field];
            updatedFields.push(field);
          }
        });
        commit('SET_REG2', newReg2);
      }
      return updatedFields;
    } catch {
      return [];
      // Data from call not required
      // No need to flash error message here
      // Logging happens in railsAxios
    }
  },
  mergeRegistrationState({ commit }, payload) {
    const disabledFieldNames = [];
    if (payload !== undefined && payload.reg2 !== undefined) {
      if (payload.reg2.mother_name) {
        disabledFieldNames.push('mother_name');
      }
      if (payload.reg2.gender) {
        disabledFieldNames.push('gender');
      }
      if (payload.reg2.nationality) {
        disabledFieldNames.push('nationality');
      }
      if (payload.reg2.birth_region) {
        disabledFieldNames.push('birth_region');
      }
    }
    commit('MERGE_REGISTRATION_STATE', payload);
    commit('SET_DISABLED_FIELD_NAMES', disabledFieldNames);
    if (payload !== undefined) {
      commit('SET_HAS_VALID_SCR_CONSENT', payload.privacy_policy);
      commit('SET_HAS_WHATSAPP_CONSENT', payload.whatsapp_consent);
      commit('SET_HAS_POSITIVE_CREDIT_DATA_CONSENT', payload.positive_credit_data_consent);
    }
  },
};

export default actions;
